import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-add",
  "use": "icon-add-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-add\"><path d=\"M533.333333 981.333333a21.333333 21.333333 0 0 1-21.333333-21.333333V554.666667H106.666667a21.333333 21.333333 0 0 1 0-42.666667h405.333333V106.666667a21.333333 21.333333 0 0 1 42.666667 0v405.333333h405.333333a21.333333 21.333333 0 0 1 0 42.666667H554.666667v405.333333a21.333333 21.333333 0 0 1-21.333334 21.333333z\" fill=\"#5C5C66\" p-id=\"6773\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol